export default __webpack_public_path__ + "static/media/tuzvv.b9d756e3.jpg";